<template>
  <div class="flex h-full flex-col items-stretch">
    <MyLocationDialog
      :show="showMyLocationDialog"
      @close="closeMyLocationDialog"
    />
    <div class="mx-8 mb-4 mt-10 flex flex-col items-start">
      <button
        class="flex items-center gap-2"
        @click="emit('go-back')"
      >
        <IconArrowRight class="size-8 rotate-180 md:hidden" />
        <h2 class="block text-xl font-medium leading-none">История заказов</h2>
      </button>
      <h3 class="ml-10 block text-sm font-medium text-black opacity-50 md:ml-0">
        Последние 20 заказов за последние 90 дней
      </h3>
    </div>

    <div class="mx-4 h-px bg-black opacity-10"></div>

    <Transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="orders?.length < 1"
        class="flex h-0 grow items-center justify-center p-8"
      >
        <div>
          <img
            src="~/assets/samoe-vremya-zakazat.svg"
            alt=""
            class="mb-6 h-48 w-full object-contain object-center"
          />
          <strong class="mb-2 block text-center text-2xl font-medium">
            Самое время заказать <br />
            что-то вкусное
          </strong>
          <p class="mb-8 text-center">Укажите адрес доставки на карте и выберете ресторан</p>
          <SimpleButton
            class="w-full px-8 py-4 font-medium uppercase"
            @click="showMyLocationDialog = true"
          >
            Выбрать адрес
          </SimpleButton>
        </div>
      </div>

      <div
        v-else
        class="relative my-2 h-0 grow"
      >
        <div class="absolute left-0 right-0 top-0 h-4 bg-gradient-to-b from-whitegray to-transparent"></div>
        <div class="absolute bottom-0 left-0 right-0 h-4 bg-gradient-to-t from-whitegray to-transparent"></div>
        <div
          class="flex h-full flex-col items-stretch gap-8 overflow-y-auto pt-8 text-xs md:gap-16 md:pt-16 md:text-base"
        >
          <ul
            v-if="orders?.length"
            class="flex flex-col gap-6"
          >
              <template
                  v-for="o in orders"
                  :key="o.id"
              >
                  <li
                      v-if="o.active"
                  >
                      <div class="mx-4 rounded-xl bg-white p-4 shadow-main lg:mx-8">
                          <div class="mb-4 flex items-center justify-between">

                              <div v-if="o.payment_type == 'online'">
                                  <div v-if="o.paid">
                                      Заказ оплачен
                                  </div>
                                  <div v-else class="flex gap-2 flex-wrap">
                                      <OrderPaymentButton :orderId="o.id"></OrderPaymentButton>
                                      <OrderPaymentButton :orderId="o.id" method="sbp"></OrderPaymentButton>
                                  </div>

                              </div>

                              <template v-if="o.can_be_cancelled">
                                  <div>
                                      <CountdownButton label="Отменить" :start="o.created_at" :duration-seconds="60" @click="showCancelConfirmation = true" />
                                  </div>

                                  <ConfirmDialog
                                      message="Вы уверены, что хотите отменить заказ?"
                                      :show="showCancelConfirmation"
                                      @confirmed="onConfirmCancel(o)"
                                      @rejected="showCancelConfirmation = false"
                                      @close="showCancelConfirmation = false"
                                  />
                              </template>

                          </div>
                          <div class="flex w-full">
                              <div class="shrink-0 grow-[1] basis-0">{{ o.id }}</div>
                              <div class="shrink-0 grow-[2] basis-0">{{ formatDate(o.created_at) }}</div>
                              <div class="shrink-0 grow-[1] basis-0">{{ o.total_sum }} &#8381;
                              </div>
                              <div class="shrink grow-0 basis-0">
                                  <ProfileDesktopDialogOrdersHistoryReceipt :order="o" />
                              </div>
                          </div>
                      </div>
                      <div class="flex flex-col items-center mx-4 rounded-xl bg-white p-5 shadow-main lg:mx-8 mt-1">
                          <div class="flex gap-6 items-center">
                              <div class="h-10 w-10 rounded-xl p-2 button-with-status flex justify-center" :class="{ 'button-with-status-active' : o.status == 'received'}">
                                  <img src="~/assets/icon/icon-checkmark.svg" alt="">
                              </div>

                              <div class="flex gap-1">
                                  <div class="w-1 h-1 bg-gray2-100 rounded-full"></div>
                                  <div class="w-1 h-1 bg-gray2-100 rounded-full hidden sm:block"></div>
                                  <div class="w-1 h-1 bg-gray2-100 rounded-full hidden sm:block"></div>
                              </div>

                              <div class="h-10 w-10 rounded-xl p-2 button-with-status flex justify-center" :class="{ 'button-with-status-active' : o.status == 'cooking'}">
                                  <img src="~/assets/icon/icon-hat.svg" alt="">
                              </div>

                              <div class="flex gap-1">
                                  <div class="w-1 h-1 bg-gray2-100 rounded-full"></div>
                                  <div class="w-1 h-1 bg-gray2-100 rounded-full hidden sm:block"></div>
                                  <div class="w-1 h-1 bg-gray2-100 rounded-full hidden sm:block"></div>
                              </div>

                              <template v-if="o.delivery_by_courier">
                                  <div class="h-10 w-10 rounded-xl p-2 button-with-status flex justify-center" :class="{ 'button-with-status-active' : o.status == 'on_way'}">
                                      <img src="~/assets/icon/icon-car.svg" alt="">
                                  </div>

                                  <div class="flex gap-1">
                                      <div class="w-1 h-1 bg-gray2-100 rounded-full"></div>
                                      <div class="w-1 h-1 bg-gray2-100 rounded-full hidden sm:block"></div>
                                      <div class="w-1 h-1 bg-gray2-100 rounded-full hidden sm:block"></div>
                                  </div>
                              </template>


                              <div class="h-10 w-10 rounded-xl p-2 button-with-status flex justify-center" :class="{ 'button-with-status-active' : o.status == 'completed' || (!o.delivery_by_courier && o.status == 'on_way')}">
                                  <img src="~/assets/icon/icon-flag.svg" alt="">
                              </div>
                          </div>

                          <div class="mt-5 text-center">
                              <div class="whitespace-pre">
                                  {{ o.status_text }}
                              </div>
                              <div v-if="!o.paid && o.payment_type == 'online'">
                                  Ожидаем оплату...
                              </div>
                          </div>
                      </div>

                  </li>
              </template>
          </ul>

          <div class="min-h-96 grow px-4 pb-8 lg:px-8">
            <div class="flex h-full flex-col items-stretch">
              <div class="mb-2 flex w-full rounded-xl bg-gray px-4 py-2">
                <div class="shrink-0 grow-[1] basis-0">№</div>
                <div class="shrink-0 grow-[2] basis-0">Время заказа</div>
                <div class="shrink-0 grow-[1] basis-0">Сумма</div>
                <div class="shrink-0 grow-[2] basis-0">&nbsp;</div>
              </div>

              <div class="relative h-0 flex-auto">
                <div class="absolute left-0 right-0 top-0 h-4 bg-gradient-to-b from-white to-transparent"></div>
                <div class="absolute bottom-0 left-0 right-0 h-4 bg-gradient-to-t from-white to-transparent"></div>
                <ul class="scrollbar-hide flex h-full flex-col items-stretch gap-2 overflow-y-auto scroll-smooth py-4">
                    <template v-for="o in orders"
                              :key="o.id">
                        <li
                            v-if="!o.active"
                            class="flex w-full rounded-xl bg-white px-4 py-2 shadow-main"
                        >
                            <div class="shrink-0 grow-[1] basis-0">{{ o.id }}</div>
                            <div class="shrink-0 grow-[2] basis-0">{{ formatDate(o.created_at) }}</div>
                            <div class="shrink-0 grow-[1] basis-0">{{ o.total_sum }} &#8381;</div>
                            <div class="flex gap-5 justify-end shrink-0 grow-[2] basis-0">
                                <ProfileDesktopDialogOrdersHistoryReceipt :order="o" />
                                <OrderRepeat :order-id="o.id" @repeat-order="onRepeatOrder()"></OrderRepeat>
                            </div>
                        </li>
                    </template>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { getOrderStatusString, pad } from '~/utils'
import { useProfileDialogStore } from '~/store/profileDialog'
import { formatDistance, formatDistanceStrict } from 'date-fns'
import { ru } from 'date-fns/locale'
import { useQueryClient } from '@tanstack/vue-query'
import type { Order } from '~/interfaces/users'
import { useToast } from 'vue-toastification'
import MyToast from '~/components/MyToast.vue'
import Countdown from '~/components/Countdown.vue'
import CountdownButton from '~/components/CountdownButton.vue'

const emit = defineEmits(['go-back'])

onMounted(() => {
    const queryClient = useQueryClient()
    queryClient.invalidateQueries({ queryKey: ['user','orders'] })
})


const { data: orders } = useOrders(
  (v) => v,
  (query) => {
    if (query.state.data?.find((order) => order.active)) {
      return 60 * 1000
    }
    return false
  }
)

const profileDialogStore = useProfileDialogStore()

const onRepeatOrder = () => {
    emit('go-back')
    profileDialogStore.close()
}
const formatDate = (d: string) => {
  const date = new Date(Date.parse(d))
    const formatter = new Intl.DateTimeFormat('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric', minute: '2-digit', hour: '2-digit' });
    return formatter.format(date);
}



const showMyLocationDialog = ref(false)
const closeMyLocationDialog = () => {
  showMyLocationDialog.value = false
  profileDialogStore.close()
}

const queryClient = useQueryClient()
const showCancelConfirmation = ref(false)
const toast = useToast()
const privateAxios = usePrivateAxiosInstance()
const onConfirmCancel = async (order: Order) => {
    const response = await privateAxios.post<string>("user/order/"+order.id, {status: "cancelled"}).then(() => {
        toast({
            component: MyToast,
            props: {
                title: 'Заказ отменен',
            },
        })
        queryClient.invalidateQueries({ queryKey: ['user','orders'] })
    }).finally(() => {
        showCancelConfirmation.value = false
    })
}
</script>
